<template>
	<span v-if="params.value" :class="['company-name', { 'company-name--detail': detailId !== null }]" :role="detailId !== null ? 'button' : undefined" :tabindex="detailId !== null ? 0 : undefined" @click="openDetail" @keydown.enter="openDetail">
		<span v-if="detailId !== null" class="company-name__icon"><v-icon size="18">storefront</v-icon></span>
		<span class="company-name__label">{{ params.value }}</span>
	</span>
</template>

<script setup>
import { computed } from 'vue';
import { findDeliveryLocationDetailId, handleEditDeliveryLocation } from '@/utils/domain/appointmentUtils';

const props = defineProps({
	params: { type: Object, required: true },
});

const detailId = computed(() => findDeliveryLocationDetailId(props.params?.deliveryLocationId));

function openDetail(event) {
	if (detailId.value === null) return;
	event.stopPropagation();
	handleEditDeliveryLocation(detailId.value);
}
</script>

<style lang="scss">
.company-name {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	max-width: 100%;
	vertical-align: middle;

	&__icon {
		display: inline-flex;
		flex-shrink: 0;
		color: rgb(var(--v-theme-primary));
	}

	&__label {
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&--detail {
		cursor: pointer;

		&:hover .company-name__label {
			text-decoration: underline;
		}
	}
}
</style>
